export const sedan = [
  {
    id: 1,
    name: "Maruti Suzuki Dzire AC",
    image: "/images/gallery/sedan/suzuki-dzire.png",

    gallery: [
      "/images/gallery/sedan/suzuki-dzire.png",
      "/images/gallery/sedan/suzuki-dzire-interior.jpg",
      "/images/gallery/sedan/suzuki-dzire-tyre.jpg"
    ],

    body: "Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1197 cc",
    transmission: "Manual / Automatic",
    fuel: "Petrol / CNG",
    ac: "AC"
  },

  {
    id: 2,
    name: "Hyundai Aura AC",
    image: "/images/gallery/sedan/aura.png",

    gallery: [
      "/images/gallery/sedan/aura.png",
      "/images/gallery/sedan/aura-interior.jpg",
      "/images/gallery/sedan/aura-tyre.jpg"
    ],

    body: "Sedan",
    seats: "4 + 1",
        doors: "4",
    engine: "1197 cc",
    transmission: "Manual / Automatic",
    fuel: "Petrol / CNG",
    ac: "AC"
  },

  {
    id: 3,
    name: "Hyundai Xcent AC",
    image: "/images/gallery/sedan/xcent.png",

    gallery: [
      "/images/gallery/sedan/xcent.png",
      "/images/gallery/sedan/xcent-interior.jpg",
      "/images/gallery/sedan/xcent-tyre.jpg"
    ],

    body: "Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1197 cc",
    transmission: "Manual",
    fuel: "Petrol / CNG",
    ac: "AC"
  },

  // {
  //   id: 4,
  //   name: "Toyota Etios AC",
  //   image: "/images/gallery/sedan/etios.png",

  //   gallery: [
  //     "/images/gallery/sedan/etios.png",
  //     "/images/gallery/sedan/etios-interior.jpg",
  //     "/images/gallery/sedan/etios-tyre.jpg"
  //   ],

  //   body: "Sedan",
  //   seats: "4 + 1",
  //   doors: "4",
  //   engine: "1496 cc",
  //   transmission: "Manual",
  //   fuel: "Petrol / Diesel",
  //   ac: "AC"
  // },

  {
    id: 4,
    name: "Toyota Glanza Latest Model",
    image: "/images/gallery/sedan/toyota-glanza.png",

    gallery: [
      "/images/gallery/sedan/toyota-glanza.png",
      "/images/gallery/sedan/toyota-glanza-interior.jpg",
      "/images/gallery/sedan/toyota-glanza-back.jpg"
    ],

    body: "Sedan",
    seats: "4 + 1",
    doors: "5",
    engine: "1197 cc",
    transmission: "Manual / Automatic",
    fuel: "Petrol / CNG",
    ac: "AC"
  }
];
